// AIT-639 — ChatGPT Ads measurement pixel for the web/ marketing site.
// Mirrors web/app/lib/firstpromoter.ts: SSR-safe, idempotent, no-op without
// a pixel id. The SDK captures the `oppref` click id from the landing URL
// into a first-party cookie (Domain=.hookmyapp.com) so the signup on
// app.hookmyapp.com (frontend/src/lib/openai-pixel.ts) attributes back to
// the ad. No events are measured here; registration fires in frontend/.
//
// Docs: https://developers.openai.com/ads/measurement-pixel

type OaiqQueue = { (...args: unknown[]): void; q?: unknown[][] };

let initialized = false;

export function initOpenAIPixel(): void {
  if (typeof window === 'undefined' || initialized) return;
  const pixelId = import.meta.env.VITE_OPENAI_PIXEL_ID;
  if (!pixelId) return;

  const w = window as Window & { oaiq?: OaiqQueue };
  if (!w.oaiq) {
    const oaiq: OaiqQueue = (...args: unknown[]) => {
      oaiq.q = oaiq.q || [];
      oaiq.q.push(args);
    };
    w.oaiq = oaiq;
  }
  w.oaiq('init', { pixelId });

  const script = document.createElement('script');
  script.async = true;
  script.src = 'https://bzrcdn.openai.com/sdk/oaiq.min.js';
  document.head.appendChild(script);

  initialized = true;
}
